import { Modal as FlowbiteModal } from "flowbite-react";
import { ReactNode } from "react";

import { CloseModalIcon } from "../SVGIcons";

interface ModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl";
  icon?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

const Modal = ({
  show,
  onClose,
  title,
  size = "md",
  icon,
  actions,
  children
}: ModalProps) => {
  return (
    <FlowbiteModal show={show} size={size} onClose={onClose}>
      <div
        aria-hidden="true"
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <button
              className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              type="button"
              onClick={onClose}
            >
              <CloseModalIcon />
              <span className="sr-only">閉じる</span>
            </button>
            <div className="p-4 md:p-5">
              {icon && <div className="mb-2">{icon}</div>}
              {title && (
                <h3 className="text-base font-semibold leading-6 text-gray-900">
                  {title}
                </h3>
              )}
              <div className="mt-2">
                {children}
              </div>
              {actions && (
                <div className="flex flex-row-reverse items-center mt-6 space-x-4">
                  {actions}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </FlowbiteModal>
  );
};

export default Modal; 